import { useNavigate } from "react-router-dom";
import { Compass } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Button } from "../components/ui/button";

export default function NotFound() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  return (
    <div className="App bg-[#FBFBF9] min-h-screen flex flex-col overflow-x-hidden" data-testid="notfound-page">
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-24">
        <div className="max-w-lg text-center">
          <span aria-hidden="true" className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-[#D8E3DC]">
            <Compass className="h-6 w-6 text-[#1E3A2B]" />
          </span>
          <p className="mt-6 font-mono-label text-[10px] text-[#5B655F]">404</p>
          <h1 className="mt-2 font-heading text-3xl sm:text-4xl font-semibold text-[#1A1F1C]">{t("notfound.title")}</h1>
          <p className="mt-3 text-base text-[#525B56] leading-relaxed">{t("notfound.body")}</p>
          <Button data-testid="notfound-home" onClick={() => navigate("/")} className="mt-8 rounded-full bg-[#1E3A2B] hover:bg-[#14281E] text-[#FBFBF9] px-6">
            {t("notfound.cta")}
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
